import { useGetLoginInfo } from '@multiversx/sdk-dapp/hooks/account'
import * as DappUI from '@multiversx/sdk-dapp/UI'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import SvgIcon from '@mui/material/SvgIcon'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'

const ConnectMvxInfo = ({ infoText }: { infoText: string }) => {
  const { isLoggedIn } = useGetLoginInfo()
  const { WebWalletLoginButton } = DappUI

  return isLoggedIn ? null : (
    <Grid container spacing={2}>
      {infoText ? (
        <Grid
          item
          xs={12}
          sm={10}
          md={8}
          lg={8}
          xl={9}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}>
          <Paper
            elevation={0}
            sx={{
              background: 'rgba(211, 47, 47, 0.15)',
              color: '#fff',
              padding: '18px 10px',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'flex-start',
              gap: '15px',
              width: '100%',
              boxSizing: 'border-box',
              borderRadius: '8px',
            }}>
            <SvgIcon component={ErrorOutlineOutlinedIcon} sx={{ color: 'rgba(211, 47, 47, 1)' }} />
            <Typography
              variant="body1"
              sx={{
                fontWeight: '500',
                color: 'rgba(211, 47, 47, 1)',
                fontFamily: 'SpaceGrotesk, sans-serif',
              }}>
              {infoText}
            </Typography>
          </Paper>
        </Grid>
      ) : null}
      <Grid
        item
        xs={9}
        sm={6}
        md={4}
        lg={4}
        xl={3}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}>
        <WebWalletLoginButton
          callbackRoute={window.location.pathname + window.location.search}
          buttonClassName="mvx-button"
          nativeAuth={false}>
          <div>Connect wallet</div>
        </WebWalletLoginButton>
      </Grid>
    </Grid>
  )
}

export default ConnectMvxInfo
